import DOMPurify from 'isomorphic-dompurify';
import type { Config } from 'isomorphic-dompurify';

export function sanitizeHtml(html?: string | null, config?: Config): string {
    if (html && config) {
        const clean = DOMPurify.sanitize(html, config);
        return typeof clean === 'string' ? clean : '';
    }
    if (html) {
        return DOMPurify.sanitize(html);
    }
    return '';
}
